import {scriptonload} from '../modules/scriptonload';

var header = function (el) {
    scriptonload('/static/js/vendors/stickyfill.min.js', function(){ Stickyfill.add(el)});
};

export {header};